<template>
    <div class="order-manage">
        <div class="title-info">
            <div class="optimize-title-top">
                <div class="optimize-title01">网店订单管理</div>
                <el-button type="primary"  @click="addOrderBtn()">添加订单</el-button>
            </div>
        </div>
        <el-table :data="orderManagementContent" style="width: 100%; flex: 1" size="medium" border
                  :header-cell-style="{fontWeight: 'normal', color: '#666', background: '#F6F6F6',fontSize: '16px',height:'60px'}"
                  :cell-style="{fontSize: '12px',color: '#333',height: '70px'}">
            <el-table-column prop="order_no" label="订单编号"></el-table-column>
            <el-table-column prop="status_name" label="订单状态" align="center"></el-table-column>
            <el-table-column prop="scoring_operation" label="得分操作" align="center"></el-table-column>
            <el-table-column prop="score" label="分值" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="220px">
                <template slot-scope="scope">
                    <div class="link-list">
                        <el-link type="success" :underline="false" @click="editGoods(scope.row,scope.$index)">编辑</el-link>
                        <el-link type="danger" :underline="false" @click="deleteGoods(scope.$index)">删除</el-link>
                    </div>
                </template>
            </el-table-column>
            <template slot="empty">
                <div class="null-data">
                    <div style="display: flex;flex-direction: column;align-items: center;">
                        <img src="../../../../../assets/images/admin/null-order-data.png" alt="">
                        <span>暂无订单</span>
                    </div>
                </div>
            </template>
        </el-table>
        <div slot="footer" class="dialog-footer">
            <el-button size="medium">取消</el-button>
            <el-button size="medium" type="primary" @click="saveOrder()">保存</el-button>
        </div>
        <!--订单弹窗-->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="dialogTitle" custom-class="green-dialog02" :visible.sync="orderDialogVisible"
                @close="resetForm()" width="500px">
            <el-form  :model="addOrderForm" ref="addOrderForm" :rules="addOrderRules" :label-width="formLabelWidth"
                     label-position="right" :hide-required-asterisk="true">
                <el-form-item label="商品主图" prop="img">
                    <span class="school-prompt">(尺寸要求800*800的png、jpg和jpeg的图片)</span>
                    <div class="goods-img-box" v-if="addOrderForm.file">
                        <div class="src-box">
                            <img :src="addOrderForm.file" alt="">
                        </div>
                        <i  @click="clearImg()" class="el-icon-error clear-good-img"></i>
                    </div>
                    <el-upload class="goods-uploader"
                               v-else
                               action="operationProblem/uploadGoodsImg"
                               :headers="headersParams"
                               name="file"
                               accept=".jpg, .jpeg, .png"
                               :show-file-list="false"
                               :on-success="handleCoverSuccess"
                               :before-upload="beforeCoverUpload">
                        <i class="el-icon-plus goods-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="标题"  :label-width="formLabelWidth"  prop="goods_title">
                    <el-input v-model="addOrderForm.goods_title"  autocomplete="off" placeholder="请输入标题"></el-input>
                </el-form-item>
                <el-form-item label="订单编号"  prop="order_no">
                    <template slot-scope="scope">
                        <div style="display: flex;justify-content: space-between">
                            <el-input-number v-model="addOrderForm.order_no" :precision="0" :controls="false" placeholder="请输入订单编号" style="width: 354px;margin-right: 10px"></el-input-number>
                            <el-button type="primary" plain @click="randomGeneration()">随机生成</el-button>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item label="单价"  prop="unit_price">
                    <el-input-number v-model="addOrderForm.unit_price" :precision="0" :controls="false" placeholder="请输入单价" style="width: 380px"></el-input-number>
                </el-form-item>
                <el-form-item label="数量"   prop="number">
                    <el-input-number v-model="addOrderForm.number" :precision="0" :controls="false" placeholder="请输入数量" style="width: 380px"></el-input-number>
                </el-form-item>
                <el-form-item label="实付金额"  prop="pay_amount">
                    <el-input-number v-model="addOrderForm.pay_amount" :precision="0" :controls="false" placeholder="请输入实付金额" style="width: 380px"></el-input-number>
                </el-form-item>
                <el-form-item label="订单状态" prop="order_status_id">
                    <el-select v-model="addOrderForm.order_status_id" placeholder="选择订单状态" style="width: 380px" @change="changeOrder">
                        <el-option
                                v-for="item in orderStatusList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="得分操作"  prop="scoring_operation">
                    <el-select v-model="addOrderForm.scoring_operation" placeholder="选择得分操作" style="width: 380px" @change="changeScoringOperation">
                        <el-option
                                v-for="item in scoringOperationList"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="初始物流" prop="logistics"
                 v-if="addOrderForm.order_status_id===1&&addOrderForm.scoring_operation==='出库'||
                addOrderForm.order_status_id===2&&addOrderForm.scoring_operation==='修改快递单号'||
                addOrderForm.order_status_id===3&&addOrderForm.scoring_operation==='退货审核（驳回）'||
                addOrderForm.order_status_id===3&&addOrderForm.scoring_operation==='退货审核（通过）'||
                addOrderForm.order_status_id===4&&addOrderForm.scoring_operation==='退货审核（驳回）'||
                addOrderForm.order_status_id===4&&addOrderForm.scoring_operation==='退货审核（通过）'||
                addOrderForm.order_status_id===5&&addOrderForm.scoring_operation==='退货审核（驳回）'||
                addOrderForm.order_status_id===5&&addOrderForm.scoring_operation==='退货审核（通过）'">
                    <el-select v-model="addOrderForm.logistics" placeholder="选择初始物流" style="width: 380px">
                        <el-option
                                v-for="item in logisticsList"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="初始单号"  prop="odd_numbers"
                 v-if="addOrderForm.order_status_id===2&&addOrderForm.scoring_operation==='修改快递单号'||
                addOrderForm.order_status_id===4&&addOrderForm.scoring_operation==='退货审核（驳回）'||
                addOrderForm.order_status_id===4&&addOrderForm.scoring_operation==='退货审核（通过）'||
                addOrderForm.order_status_id===5&&addOrderForm.scoring_operation==='退货审核（驳回）'||
                addOrderForm.order_status_id===5&&addOrderForm.scoring_operation==='退货审核（通过）'">
                    <el-input-number v-model="addOrderForm.odd_numbers" :precision="0" :controls="false" placeholder="请输入初始单号" style="width: 380px"></el-input-number>
                </el-form-item>
                <el-form-item label="出库方式" prop="delivery_mode"
                    v-if="addOrderForm.order_status_id===1&&addOrderForm.scoring_operation==='出库'||
                    addOrderForm.order_status_id===2&&addOrderForm.scoring_operation==='修改快递单号'">
                    <el-select v-model="addOrderForm.delivery_mode" placeholder="选择出库方式" style="width: 380px">
                        <el-option
                                v-for="item in deliveryModeList"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="物流单号" prop="logistics_number"
                              v-if="addOrderForm.order_status_id===1&&addOrderForm.scoring_operation==='出库'||
                              addOrderForm.order_status_id===2&&addOrderForm.scoring_operation==='修改快递单号'">
                    <el-input-number v-model="addOrderForm.logistics_number" :controls="false" style="width: 380px"></el-input-number>
                </el-form-item>
                <el-form-item label="出库情况"  prop="operation"
                 v-if="addOrderForm.order_status_id===3&&addOrderForm.scoring_operation==='退款审核（驳回）'||
                addOrderForm.order_status_id===3&&addOrderForm.scoring_operation==='退款审核（通过）'||
                addOrderForm.order_status_id===4&&addOrderForm.scoring_operation==='退款审核（驳回）'||
                addOrderForm.order_status_id===4&&addOrderForm.scoring_operation==='退款审核（通过）'">
                    <el-select v-model="addOrderForm.operation" placeholder="选择出库情况" style="width: 380px">
                        <el-option
                                v-for="item in operationList"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审核原因"  prop="audit_reasons"
                              v-if="addOrderForm.order_status_id===5&&addOrderForm.scoring_operation==='退货审核（驳回）'||
                addOrderForm.order_status_id===5&&addOrderForm.scoring_operation==='退货审核（通过）'||
                addOrderForm.order_status_id===5&&addOrderForm.scoring_operation==='换货审核（驳回）'||
                addOrderForm.order_status_id===5&&addOrderForm.scoring_operation==='换货审核（通过）'">
                    <el-select v-model="addOrderForm.audit_reasons" placeholder="选择审核原因" style="width: 380px">
                        <el-option
                                v-for="item in auditReasonsList"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="驳回原因"  prop="reasons_rejection"
                 v-if="addOrderForm.order_status_id===3&&addOrderForm.scoring_operation==='退货审核（驳回）'||
                addOrderForm.order_status_id===4&&addOrderForm.scoring_operation==='换货审核（驳回）'||
                addOrderForm.order_status_id===5&&addOrderForm.scoring_operation==='退货审核（驳回）'||
                addOrderForm.order_status_id===5&&addOrderForm.scoring_operation==='换货审核（驳回）'">
                    <el-select v-model="addOrderForm.reasons_rejection" placeholder="选择驳回原因" style="width: 380px">
                        <el-option
                                v-for="item in reasonsRejectionList"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="分值"  prop="score">
                    <el-input-number v-model="addOrderForm.score" :min="0.1" :max="100" :precision="1" :controls="false" style="width: 380px"></el-input-number>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button  @click="orderDialogVisible = false">取 消</el-button>
                <el-button style="margin-left: 30px" type="primary" @click="confirmForm('addOrderForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {operationProblemSaveOrderManagement,operationProblemOrderStatus,operationProblemGetOperation} from '@/utils/apis'
    export default {
        name: "OrderManage",
        props:['practiceForm'],
        data(){
            return{
                orderTable:[],
                orderTableIndex:[],
                formLabelWidth: '80px',
                dialogTitle:'',//弹窗标题
                orderDialogVisible:false,//弹窗
                addOrderForm:{
                    file:'',
                    goods_img:'',
                    goods_title:'',
                    order_no:void 0,
                    unit_price:void 0,
                    logistics_number:void 0,
                    number:void 0,
                    pay_amount:void 0,
                    order_status_id:'',
                    order_status_name:'',
                    scoring_operation:'',
                    logistics:'',
                    odd_numbers:void 0,
                    delivery_mode:'',
                    operation:'',
                    reasons_rejection:'',
                    audit_reasons:'',
                    score:void 0,
                },
                orderStatusList:[],
                scoringOperationList:[],//得分操作
                logisticsList:[],//初始物流
                deliveryModeList:[],//出库方式
                operationList:[],//出库情况
                reasonsRejectionList:[],//驳回原因
                auditReasonsList:[],//驳回原因
                orderManagementContent:[],//订单管理内容
                addOrderRules: {
                        goods_img: { required: true, message: '请上传商品主图', trigger: 'change' },
                        goods_title: { required: true, message: '请输入商品标题', trigger: 'blur' },
                        order_no: { required: true, message: '请输入订单编号', trigger: ['blur','change'] },
                        unit_price: { required: true, message: '请输入单价', trigger: 'blur' },
                        logistics_number: { required: true, message: '请输入物流单号', trigger: 'blur' },
                        number: { required: true, message: '请输入数量', trigger: 'blur' },
                        pay_amount: { required: true, message: '请输入实付金额', trigger: 'blur' },
                        order_status_id: [{ required: true, message: '请选择订单状态', trigger: 'change' }],
                        scoring_operation: [{ required: true, message: '请选择得分操作', trigger: 'change' }],
                        logistics: [{ required: true, message: '请选择初始物流', trigger: 'change' }],
                        odd_numbers: { required: true, message: '请输入初始单号', trigger: 'blur' },
                        delivery_mode: [{ required: true, message: '请选择出库方式', trigger: 'change' }],
                        operation: [{ required: true, message: '请选择出库情况', trigger: 'change' }],
                        score: { required: true, message: '请输入分值', trigger: 'blur' },

                },
                headersParams:{
                    Authorization: localStorage.getItem('adminToken') || ''
                },
                // headerSrc:null,
                // hostUrl:localStorage.getItem('hosturl') || '',
            }
        },
        mounted() {
            this.getOrderStatus()
        },
        methods:{
            //添加订单
            addOrderBtn(){
                this.dialogTitle='添加订单';
                this.orderDialogVisible=true;
                this.orderTableIndex = -1;
            },
            //编辑
            editGoods(row,index){
                this.dialogTitle='编辑订单';
                this.orderDialogVisible=true
                this.addOrderForm.file= row.goods_img;
                this.addOrderForm.goods_title= row.goods_title;
                this.addOrderForm.order_no= row.order_no;
                this.addOrderForm.unit_price= row.unit_price;
                this.addOrderForm.logistics_number= row.logistics_number;
                this.addOrderForm.number= row.number;
                this.addOrderForm.pay_amount= row.pay_amount;
                this.addOrderForm.order_status_id= row.order_status;
                this.addOrderForm.order_status_name=row.status_name;
                this.addOrderForm.scoring_operation= row.scoring_operation;
                this.addOrderForm.logistics= row.logistics;
                this.addOrderForm.odd_numbers= row.odd_numbers;
                this.addOrderForm.delivery_mode= row.delivery_mode;
                this.addOrderForm.operation= row.operation;
                this.addOrderForm.reasons_rejection= row.reasons_rejection;
                this.addOrderForm.audit_reasons= row.audit_reasons;
                this.addOrderForm.score= row.score;
                this.orderTableIndex = index;
            },
            changeOrder(val){
                console.log(val,'diangd')
              this.addOrderForm.order_status_id =val;
                for (let i in this.orderStatusList){
                    if(this.orderStatusList[i].id===val){
                        this.addOrderForm.order_status_name = this.orderStatusList[i].name;
                        break;
                    }
                }
              this.getOperation()
            },
            changeScoringOperation(val){
                this.addOrderForm.scoring_operation =val;
                this.getOperation()
            },
            //获取订单状态
            getOrderStatus(){
                operationProblemOrderStatus().then((res) => {
                    this.orderStatusList = res.data
                    this.$message.success(res.msg);
                }).catch((err) => {
                    console.log(err);
                });
            },
            //获取
            getOperation(){
                let param ={
                    status:this.addOrderForm.order_status_id,
                    scoring_operation:this.addOrderForm.scoring_operation
                }
                operationProblemGetOperation(param).then((res) => {
                    this.scoringOperationList = res.data.scoring_operation
                    this.logisticsList = res.data.logistics
                    this.deliveryModeList = res.data.delivery_mode
                    this.operationList = res.data.delivery_status
                    this.reasonsRejectionList = res.data.reasons_rejection
                    this.auditReasonsList = res.data.audit_reasons
                    this.$message.success(res.msg);
                }).catch((err) => {
                    console.log(err);
                });
            },
            // start 上传图片
            beforeCoverUpload(file) {
                const is2M = file.size / 1024 / 1024 < 10;
                if (!is2M) {
                    this.$message.warning('图片尺寸限制为800px x 800px，大小不可超过2MB');
                    return false;
                } else {
                    const isSize = new Promise((resolve, reject) => {
                        const width = 800;
                        const height = 800;
                        const _URL = window.URL || window.webkitURL;
                        const img = new Image();
                        img.onload = () => {
                            const valid = img.width === width && img.height === height;
                            valid ? resolve() : reject();
                        };
                        img.src = _URL.createObjectURL(file);
                    }).then(() => {
                            return file;
                        }, () => {
                            this.$message.warning('图片尺寸限制为800px x 800px，大小不可超过2MB');
                            return Promise.reject();
                        },
                    );
                    return isSize;
                }
            },
            // 上传图片
            handleCoverSuccess(res, file){
                if (res.code === 200) {
                    // this.headerSrc = this.hostUrl + res.data; // 有域名
                    this.addOrderForm.file = res.data; //无域名
                    this.$message.success('头像上传成功')
                } else {
                    this.$message.error('头像上传失败，请稍后再试~')
                }
            },
            //删除图片
            clearImg(){
                this.addOrderForm.file = '';
            },
            //随机生成
            randomGeneration(){
                this.addOrderForm.order_no = '';
                for (let i = 0; i < 12; i++) {
                    this.addOrderForm.order_no += Math.floor(Math.random() * 10);
                }
            },
            //确定
            confirmForm(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let ob = {
                            goods_img:this.addOrderForm.file,
                            goods_title:this.addOrderForm.goods_title,
                            order_no:this.addOrderForm.order_no,
                            unit_price:this.addOrderForm.unit_price,
                            logistics_number:this.addOrderForm.logistics_number,
                            number:this.addOrderForm.number,
                            pay_amount:this.addOrderForm.pay_amount,
                            order_status:this.addOrderForm.order_status_id,
                            status_name:this.addOrderForm.order_status_name,
                            scoring_operation:this.addOrderForm.scoring_operation,
                            logistics:this.addOrderForm.logistics,
                            odd_numbers:this.addOrderForm.odd_numbers,
                            delivery_mode:this.addOrderForm.delivery_mode,
                            operation:this.addOrderForm.operation,
                            reasons_rejection:this.addOrderForm.reasons_rejection,
                            audit_reasons:this.addOrderForm.audit_reasons,
                            score:this.addOrderForm.score,
                        }
                        if (this.orderTableIndex>-1){
                            //    编辑
                            this.orderManagementContent[this.orderTableIndex] = ob;
                        }else{
                            //    新增
                            this.orderManagementContent.push(ob);
                        }
                        this.resetForm()
                        this.orderDialogVisible=false;
                        // orderManagementContent
                    } else {
                        return false;
                    }
                });
            },
            saveOrder(){
                let param = {
                    op_name: this.practiceForm.name,
                    exam_module_id: this.practiceForm.module_level_three_value,
                    category_id: this.practiceForm.classValue[this.practiceForm.classValue.length - 1],
                    assess_time: this.practiceForm.time,
                    task_goal: this.practiceForm.taskList,
                    task_background: this.practiceForm.taskBackground,
                    task_analysis: this.practiceForm.taskAnalysis,
                    task_operation: this.practiceForm.taskOperation,
                    scoring_criteria: this.practiceForm.scoreList,
                    order_management_content: this.orderManagementContent,
                }
                operationProblemSaveOrderManagement(param).then((res) => {
                    this.$message.success(res.msg)
                    this.$router.push('/practice/index')
                }).catch((err) => {
                    console.error('err', err);
                });
            },
            //删除
            deleteGoods(index){
                this.orderManagementContent.splice(index, 1);
            },
            // 重置表单
            resetForm(){
                this.$refs.addOrderForm.resetFields();
                this.addOrderForm = this.$options.data().addOrderForm;
            },
        }
    }
</script>

<style scoped lang="scss">
.order-manage{
    .title-info {
        margin-top: 34px;
        .optimize-title-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
            .optimize-title01 {
                font-size: 16px;
                color: #333;
                position: relative;
                padding-left: 16px;
                &:before {
                    content: '';
                    position: absolute;
                    width: 4px;
                    height: 16px;
                    background: #2DC079;
                    left: 0;
                    top: 4px;
                }
            }
        }
    }
    ::v-deep .el-input-number {
        .el-input__inner {
            text-align: left;
        }
    }
    .goods-img-box{
        width: 80px;
        height: 80px;
        box-sizing: border-box;
        position: relative;
        .src-box{
            width: 100%;
            height: 100%;
            overflow: hidden;
            border: 1px solid #EEEEEE;
            img{
                max-width: 100%;
                max-height: 100%;
            }
        }
        .clear-good-img {
            background: #fff;
            border-radius: 50%;
            position: absolute;
            top: -9px;
            right: -9px;
            z-index: 1;
            font-size: 18px;
            color: #aaa;
            cursor: pointer;
            transition: all .3s;
            &:hover {
                color: #ff0000;
            }
        }

    }
    .goods-uploader{
        ::v-deep.el-upload{
            width: 80px;
            height: 80px;
            background: #EEEEEE;
            display: flex;
            align-items: center;
            justify-content: center;
            .goods-uploader-icon{
                font-size: 32px;
                color: #A0A0A0;
            }
        }
    }
    .null-data{
        display: flex;
        flex-direction: column;
        align-content: center;
        margin-top: 20px;
        img{
            width: 80px;
        }
    }
    .dialog-footer{
        text-align: center;
        margin-top: 20px;
    }

}
</style>